import React from 'react';
import GreenSummary from '../../components/summary/GreenSummary';
import { useAppSelector } from '../../../../core/rootHooks';
import { RootState } from '../../../../core/store';
import DynamicTab from '../../../../shared/components/tabs/DynamicTab';

const Summary: React.FC = () => {
	const { greenSummaryData } = useAppSelector((state: RootState) => state.greenSlice);

	const tabs = [
		{
			id: 'overview',
			label: 'Overview',
			content: <GreenSummary data={greenSummaryData?.greenSummaryData || []} loading={greenSummaryData?.loading} />,
		},
	];

	return <DynamicTab items={tabs} tabColor="msi-chart-midgreen" />;
};

export default Summary;
